import script from "./PastDocumentationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastDocumentationCard.vue?vue&type=script&setup=true&lang=ts"

import "./PastDocumentationCard.vue?vue&type=style&index=0&id=4efcfeca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4efcfeca"]])

export default __exports__